import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungBamberg() {
  return (
    <CityPageTemplate
      city="Bamberg"
      slug="bamberg"
      intro="Bamberg als UNESCO-Welterbe-Stadt und Bierhauptstadt – Deine Finanzen sollten genauso reifen wie ein gutes Rauchbier."
      description="Unabhängige & digitale Finanzberatung für Bamberg: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
